/**
 * Lindorug Product Zoom — Desktop only
 * Click = zoom in (lente +), click di nuovo = zoom out (lente -).
 * Icona SVG lente in basso a destra.
 * Cursore SVG lente +/- moderno.
 */
(function() {
  'use strict';

  if (window.matchMedia('(max-width: 768px)').matches) return;

  var MAGNIFY = 1.8;
  var WRAPPER_SEL = '.product__photo-wrapper';
  var active = null;

  // SVG lente + (zoom in)
  var SVG_ZOOM_IN = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>';

  // SVG lente - (zoom out)
  var SVG_ZOOM_OUT = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="8" y1="11" x2="14" y2="11"/></svg>';

  function initZoom() {
    var wrappers = document.querySelectorAll(WRAPPER_SEL);
    if (!wrappers.length) return;

    wrappers.forEach(function(wrapper) {
      wrapper.removeAttribute('href');
      wrapper.setAttribute('data-zoomed', 'false');
      wrapper.style.overflow = 'hidden';

      // Nessuna icona sovrapposta — solo cursore SVG

      wrapper.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (this.getAttribute('data-zoomed') === 'false') {
          zoomIn(this, e);
        } else {
          zoomOut(this);
        }
      });

      wrapper.addEventListener('mousemove', function(e) {
        if (this.getAttribute('data-zoomed') === 'false') return;
        moveZoom(this, e);
      });

      wrapper.addEventListener('mouseleave', function() {
        if (this.getAttribute('data-zoomed') === 'true') {
          zoomOut(this);
        }
      });
    });
  }

  function zoomIn(wrapper, e) {
    var img = wrapper.querySelector('img:not(.lindorug-zoom-img)');
    if (!img) return;

    if (active && active !== wrapper) zoomOut(active);

    var src = img.getAttribute('data-src') || img.currentSrc || img.src;
    src = src.replace(/width=\d+/, 'width=2000');

    var zoomImg = wrapper.querySelector('.lindorug-zoom-img');
    if (!zoomImg) {
      zoomImg = document.createElement('img');
      zoomImg.className = 'lindorug-zoom-img';
      zoomImg.setAttribute('role', 'presentation');
      zoomImg.alt = '';
      zoomImg.style.cssText = 'position:absolute;top:0;left:0;opacity:0;pointer-events:none;' +
        'max-width:none;max-height:none;border:none;z-index:1;transition:opacity 0.15s;';
      wrapper.appendChild(zoomImg);

      zoomImg.onload = function() {
        this.style.width = (wrapper.offsetWidth * MAGNIFY) + 'px';
        this.style.height = (wrapper.offsetHeight * MAGNIFY) + 'px';
        this.style.opacity = '1';
        moveZoom(wrapper, e);
      };
      zoomImg.src = src;
    } else {
      zoomImg.style.width = (wrapper.offsetWidth * MAGNIFY) + 'px';
      zoomImg.style.height = (wrapper.offsetHeight * MAGNIFY) + 'px';
      zoomImg.style.opacity = '1';
      moveZoom(wrapper, e);
    }

    wrapper.setAttribute('data-zoomed', 'true');
    active = wrapper;

  }

  function zoomOut(wrapper) {
    var zoomImg = wrapper.querySelector('.lindorug-zoom-img');
    if (zoomImg) zoomImg.style.opacity = '0';

    wrapper.setAttribute('data-zoomed', 'false');
    if (active === wrapper) active = null;

  }

  function moveZoom(wrapper, e) {
    var zoomImg = wrapper.querySelector('.lindorug-zoom-img');
    if (!zoomImg || zoomImg.style.opacity === '0') return;

    var rect = wrapper.getBoundingClientRect();
    var x = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
    var y = Math.max(0, Math.min(1, (e.clientY - rect.top) / rect.height));

    var imgW = zoomImg.offsetWidth || wrapper.offsetWidth * MAGNIFY;
    var imgH = zoomImg.offsetHeight || wrapper.offsetHeight * MAGNIFY;

    zoomImg.style.left = -(imgW - rect.width) * x + 'px';
    zoomImg.style.top = -(imgH - rect.height) * y + 'px';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZoom);
  } else {
    initZoom();
  }
})();
